import { VariantProps, cva } from 'class-variance-authority';

export const badgeStyles = cva(
  ['rounded-4 p-4 inline-flex flex-row items-center'],
  {
    variants: {
      variant: {
        flat: ['text-grayscale600 fill-grayscale600 bg-primary50'],
        disabled: ['text-grayscale300 fill-grayscale300'],
        outlined: [
          'border border-grayscale100 fill-grayscale600 text-grayscale600',
        ],
      },
      spacing: {
        small: ['space-x-4 p-4'],
        default: ['space-x-8 p-4'],
      },
    },
  },
);

export type BadgeStyleVariants = VariantProps<typeof badgeStyles>;
